import { render } from "./StepWant.vue?vue&type=template&id=5f1f3527&scoped=true"
import script from "./StepWant.vue?vue&type=script&lang=js"
export * from "./StepWant.vue?vue&type=script&lang=js"

import "./StepWant.vue?vue&type=style&index=0&id=5f1f3527&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1f3527"]])

export default __exports__